export default {
  PERIOD: [
    { KEY: 1, VALUE: 'Segundas', LABEL: 'Segunda' },
    { KEY: 2, VALUE: 'Terças', LABEL: 'Terça' },
    { KEY: 3, VALUE: 'Quartas', LABEL: 'Quarta' },
    { KEY: 4, VALUE: 'Quintas', LABEL: 'Quinta' },
    { KEY: 5, VALUE: 'Sextas', LABEL: 'Sexta' },
    { KEY: 6, VALUE: 'Sábados', LABEL: 'Sábado' },
    { KEY: 0, VALUE: 'Domingos', LABEL: 'Domingo' },
    { KEY: 7, VALUE: 'Dias úteis', LABEL: 'Dias úteis' },
    { KEY: 8, VALUE: 'Fins de semana', LABEL: 'Fins de semana' },
  ],
  DAYS_OF_WEEK: [
    { KEY: 0, VALUE: 'Domingo' },
    { KEY: 1, VALUE: 'Segunda' },
    { KEY: 2, VALUE: 'Terça' },
    { KEY: 3, VALUE: 'Quarta' },
    { KEY: 4, VALUE: 'Quinta' },
    { KEY: 5, VALUE: 'Sexta' },
    { KEY: 6, VALUE: 'Sábado' },
    { KEY: 7, VALUE: 'Ontem' },
  ],
  MESSAGE_TYPE: {
    FILE: 'file',
    TEXT: 'text',
  },
  ACTIONS: {
    SUBSCRIBE: 'subscribe',
    ATTENDANT_PUBLISH: 'attendantPublish',
    DIALOGUE_STATUS: 'dialogueStatus',
  },
  USER_TYPES: {
    ATTENDANT: 'attendant',
    USER: 'user',
    SUPERVISOR: 'supervisor',
    GERAL: 'all',
    CHATBOT: 'chatbot',
  },
  CONVERSATION_STATUS: {
    CLOSED: 0,
    OPEN: 1,
    SNOOZED: 2,
    UNASSIGNED: 3,
  },
  SEND_CONVERSATION_STATUS: {
    CLOSED: 'closed',
    OPEN: 'open',
    SNOOZED: 'snoozed',
  },
  FILTER_CATEGORY: {
    TAGS: 'Tags',
    USERS: 'Users',
    NONE: 'None',
    ATTENDANT: 'attendants',
  },
  TAG_TYPES: [
    {
      ID: 0,
      NAME: 'Mensagens',
    },
    {
      ID: 1,
      NAME: 'Conversas',
    },
    {
      ID: 2,
      NAME: 'Geral',
    },
  ],
  TIME_TO_CHECK_WEBSOCKET_CONNECTION: 1800000,
  WEBHOOK_TYPES: [
    { KEY: 1, VALUE: 'ATTENDANT_MESSAGE' },
    { KEY: 2, VALUE: 'USER_MESSAGE' },
    { KEY: 3, VALUE: 'MESSAGE_STATUS' },
    { KEY: 4, VALUE: 'DIALOGUE_STATUS' },
  ],
  ATTENDANT_MESSAGE_STATUS: {
    VISUALIZED: 'visualized',
    SENT: 'sent',
    SENDING: 'sending',
  },
  EVENT_TYPE: {
    USER_NEW_MESSAGE: 'userNewMessage',
    TYPING_STATUS: 'typingStatus',
    GET_NEW_USER: 'getNewUser',
    CONVERSATION_STATUS: 'conversationStatus',
    USER_VISUALIZED_STATUS: 'userVisualizedMessageStatus',
    ATTENDANT_NEW_MESSAGE: 'attendantNewMessage',
    MESSAGE_STATUS: 'messageStatus',
    ATTENDANT_RECEIVED_MESSAGE_STATUS: 'attendantReceivedMessageStatus',
    ATTENDANT_VISUALIZED_MESSAGE_STATUS: 'attendantVisualizedMessageStatus',
    ATTENDANT_ASSIGNMENT: 'attendantAssignment',
  },
  TIME_UNIT: [
    {
      KEY: 0,
      LABEL: 'segundos',
      VALUE: 'second',
    },
    {
      KEY: 1,
      LABEL: 'horas',
      VALUE: 'hour',
    },
    {
      KEY: 2,
      LABEL: 'minutos',
      VALUE: 'minute',
    },
  ],
};
